<template>
	<div class="content">
		<div class="nav flex-c-s">
			<div class="nav-left flex-c-s">
				<img :src="logoTop" class="logo" alt="logo" loading="lazy">
				<span class="nav-left-text">Apetite</span>
			</div>
			<div class="tabList flex-c-s">


				<a v-for="(tab,index) in tabList" :key="index" class="tab " :href="`#${tab}`">{{tab}}</a>

			</div>
			<a href="#Contact" class="contactUs flex-c-c">
				Contact Us
			</a>
		</div>
		<div id="About">
			<div style="margin-top: 2.48rem;" class="top">Discover endless recipes for every </div>
			<div class="top">meal, every mood.</div>
			<div style="margin-top: 0.21rem;" class="tips">From quick weeknight dinners to healthy eats, baking, and
				global cuisines—
			</div>
			<div class="tips">step-by-step instructions make cooking easy for everyone.</div>
			<!-- <div class="down flex-c-s">
				<img src="../assets/btn-down-az@3x.png" alt="logo">
				<img style="margin-left: 0.53rem;" src="../assets/btn-down-ios@3x.png" alt="logo">
			</div> -->
			<img v-lazy="topBg" class="bg" alt="logo">
		</div>
		<div id="Services">
			<img class="Services-left" v-lazy="page02Left" alt="">
			<div class="Services-right">
				<div class="title">
					Why millions love our
				</div>
				<div class="title">
					recipe app
				</div>
				<div style="margin-top: 0.33rem;" class="tips flex-c-s">
					<img :src="iconMatch" alt="" class="tips-icon" loading="lazy">
					Thousands of trusted recipes, updated daily
				</div>
				<div class="tips flex-c-s">
					<img :src="iconMatch" alt="" class="tips-icon" loading="lazy">
					Step-by-step photos & video guides
				</div>
				<div class="tips flex-c-s">
					<img :src="iconMatch" alt="" class="tips-icon" loading="lazy">
					Smart recommendations based on your taste
				</div>
				<div class="tips flex-c-s">
					<img :src="iconMatch" alt="" class="tips-icon" loading="lazy">
					Save your favorites & sync across devices
				</div>
				<div style="width: 2.03rem;
		height: 0.67rem;"></div>
				<!-- <div class="getStarted flex-c-c">
					Get Started
				</div> -->
			</div>
		</div>
		<div id="Contact">
			<div class="Contact-left">
				<div style="margin-top: 1.61rem;" class="title">
					Good food made
				</div>
				<div class="title">
					simple.
				</div>
				<div class="tips">
					We believe everyone can cook, and every meal matters.
				</div>
				<div class="info flex-c-s">
					<img src="../assets/icon_page3_gs@3x.png" alt="" class="icon">

					<div class="cont">
						Hangzhou Xinghui Haowu Network Technology Co., Ltd
					</div>
				</div>
				<div class="info flex-c-s">
					<img src="../assets/icon_page3_map@3x.png" alt="" class="icon">
					<div style="display: flex;flex-direction: column;">
						<div class="cont">
							Company Address
						</div>
						<div class="info-tips">
							Room 2805-1, Building 2, Euro American Financial City, Cangqian Street, Yuhang District,
							Hangzhou, Zhejiang
						</div>
					</div>
				</div>
				<div class="info flex-c-s">
					<img src="../assets/icon_page3_phone@3x.png" alt="" class="icon">
					<div class="cont">
						+86 18667000651
					</div>
				</div>
			</div>
			<img v-lazy="page03Right" alt="" class="Contach-right">
		</div>
		<div id="Download">
			<div class="download-top">
				<img v-lazy="bgPattern" alt="" class="bg">
				<div style="margin-top: 1.17rem;" class="title">
					Download now & start
				</div>
				<div class="title">
					cooking today.
				</div>
				<div class="tips">
					Good food made simple.

				</div>
				<div class="tips">
					We believe everyone can cook, and every meal matters.
				</div>
				<!-- <div class="download-btn flex-c-s">
					<img src="../assets/btn-page04-google@3x.png" alt="">
					<img style="margin-left: 0.32rem;" src="../assets/btn-page04-ios@3x.png" alt="">
				</div> -->

			</div>
			<div class="download-bottom ">
				<div class="left">
					Copyright © 2025 Investo. All Rights Reserved
				</div>
				<div class="right flex-c-s">
					<img :src="iconMail" class="icon" alt="" loading="lazy"> Xinghuihw@gmail.com
					
				</div>
			</div>

		</div>
	</div>
</template>


<script setup>
	import { ref } from 'vue'
	const tabList = ref(['About', 'Services', 'Contact', 'Download'])

	// Vite 下建议用 import 引入静态资源（也方便 v-lazy 传 URL）
	import logoTop from '../assets/Apetite-logo-top@3x.png'
	import topBg from '../assets/img-top-bg@3x.png'
	import page02Left from '../assets/img-page02-l@3x.png'
	import iconMatch from '../assets/icon-page02-match@3x.png'
	import page03Right from '../assets/img-page03-r@3x.png'
	import bgPattern from '../assets/img-bg-pattern@3x.png'
	import iconMail from '../assets/icon_bottom_mail@3x.png'
</script>


<style scoped lang="less">
	.content {
		width: 100%;
		height: 100%;
		background: #D0D5DD;


	}

	.nav {
		position: fixed;
		width: 16.53rem;
		height: 0.99rem;
		background: #1A1A1A;
		border-radius: 1.33rem 1.33rem 1.33rem 1.33rem;
		top: 0.43rem;
		left: 50%;
		transform: translateX(-50%);
		padding: 0 0.4rem;
		box-sizing: border-box;
		z-index: 9999;
	}

	.nav-left {
		font-family: f600;
		font-weight: 600;
		font-size: 0.27rem;
		color: #FFFFFF;
	}

	.logo {
		width: 0.53rem;
		height: 0.53rem;
		border-radius: 0.13rem 0.13rem 0.13rem 0.13rem;
		margin-right: 0.11rem;
	}

	.tabList {
		display: flex;
		align-items: center;
		justify-content: space-around;
		margin-left: 3.43rem;
	}

	a {
		font-family: ff400;
		font-weight: 400;
		font-size: 0.21rem;
		color: #FFFFFF;
		margin-right: 0.67rem;
		text-decoration: none;
	}

	.contactUs {
		width: 1.99rem;
		height: 0.67rem;
		background: #FEC900;
		border-radius: 1.33rem 1.33rem 1.33rem 1.33rem;
		font-family: ff500;
		font-weight: 500;
		font-size: 0.21rem;
		color: #171717;
		margin-left: 2.71rem;
		cursor: pointer;
		flex-shrink: 0;
	}

	#About {
		width: 100vw;
		height: 11.73rem;
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	#About .top {
		font-family: ff800;
		font-weight: 800;
		font-size: 0.72rem;
		color: #000000;
		line-height: 0.89rem;
		position: relative;
		z-index: 99;
	}

	#About .tips {
		font-family: f400;
		font-weight: 400;
		font-size: 0.21rem;
		color: #000000;
		position: relative;
		z-index: 99;
	}

	.down {
		position: relative;
		z-index: 99;
	}

	.down img {
		width: 2.43rem;
		height: 0.71rem;
		margin-top: 0.32rem;
		cursor: pointer;
	}

	#About .bg {
		position: absolute;
		top: 0;
		left: 0;
		width: 100vw;
		height: 11.73rem;
	}

	#Services {
		width: 100vw;
		height: 6.93rem;
		background: #FFF;
		padding: 1.6rem 1.33rem 0 1.33rem;
		box-sizing: border-box;
		display: flex;
		align-items: center;
	}

	#Services .Services-left {
		width: 7.57rem;
		height: 5.33rem;
		margin-right: 1.72rem;

	}

	#Services .Services-right {}

	.Services-right .title {
		font-family: f800;
		font-weight: bold;
		font-size: 0.64rem;
		color: #000000;
		line-height: 0.88rem;
	}

	.Services-right .tips {
		font-family: f400;
		font-weight: 400;
		font-size: 0.24rem;
		color: #383838;
		margin-top: 0.24rem;
		line-height: 0.29rem;
	}

	.Services-right .tips .tips-icon {
		width: 0.32rem;
		height: 0.32rem;
		margin-right: 0.16rem;
	}

	.Services-right .getStarted {
		width: 2.03rem;
		height: 0.67rem;
		background: #171717;
		box-shadow: 0.05rem 15 0.3rem 0px rgba(0, 0, 0, 0.06);
		border-radius: 1.33rem 1.33rem 1.33rem 1.33rem;
		font-family: f500;
		font-weight: 500;
		font-size: 0.21rem;
		color: #FFFFFF;
		margin-top: 0.63rem;
	}

	#Contact {
		width: 100vw;
		box-sizing: border-box;
		display: flex;
		padding: 1.6rem 1.33rem 4.16rem 1.33rem;
		background: #fff;
	}

	.Contach-right {
		width: 7.68rem;
		height: 9.56rem;
		margin-left: 1.96rem;
	}

	.Contact-left .title {
		font-family: f800;
		font-weight: bold;
		font-size: 0.64rem;
		color: #171717;
		line-height: 0.88rem;
	}

	.Contact-left .tips {
		font-family: f400;
		font-weight: 400;
		font-size: 0.21rem;
		color: #595959;
		margin-top: 0.21rem;
		margin-bottom: 0.63rem;
	}

	.Contact-left .info {
		margin-bottom: 0.43rem;
	}

	.Contact-left .info .icon {
		width: 0.69rem;
		height: 0.69rem;
		margin-right: 0.32rem;
	}

	.Contact-left .info .cont {
		width: 5.88rem;
		font-family: f500;
		font-weight: 600;
		font-size: 0.32rem;
		color: #171717;
		word-break: break-all;
	}

	.Contact-left .info .info-tips {
		width: 5.88rem;
		word-break: break-all;
		font-family: f400;
		font-weight: 400;
		font-size: 0.21rem;
		color: #595959;
		margin-top: 0.21rem;
	}

	#Download {
		position: relative;
		top: -2.56rem;
		width: 100vw;
		padding: 0 1.33rem;
		box-sizing: border-box;
		box-sizing: border-box;
	}

	.download-top {
		width: 16.53rem;
		height: 6.13rem;
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.download-top .bg {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
	}

	.download-top .title {
		font-family: f800;
		font-weight: bold;
		font-size: 0.64rem;
		color: #FFFFFF;
		line-height: 0.79rem;
		position: relative;
	}

	.download-top .tips {
		position: relative;
		font-family: f400;
		font-weight: 400;
		font-size: 0.21rem;
		color: rgba(255, 255, 255, 0.8);
		margin-top: 0.21rem;
	}

	.download-btn {
		position: relative;
		margin-top: 0.91rem;
	}

	.download-top img {
		width: 2.51rem;
		height: 0.67rem;
		cursor: pointer;
	}

	.download-bottom {
		width: 16.53rem;
		margin-top: 1.09rem;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.download-bottom .left {
		font-family: f400;
		font-weight: 400;
		font-size: 0.2rem;
		color: #595959;
	}
	.download-bottom .icon{
		width: 0.32rem;
		height: 0.32rem;
		margin-right: 0.32rem;
	}
	.download-bottom .right {
		font-family: f500;
		font-weight: 500;
		font-size: 0.21rem;
		color: #171717;
		line-height: 0.32rem;
	}
</style>